import { useSetAtom } from 'jotai'
import React from 'react'

import { HStack } from '~/components/elements/HStack'
import {
  TooltipButton,
  type TooltipButtonProps,
} from '~/components/elements/TooltipButton'

import { dialogInfoAtom } from '../atoms'
import { type BrandAccount } from '../hooks/useMainQuery'

export type CommandsCellProps = {
  dataItem: BrandAccount
}

export const CommandsCell = ({ dataItem: brandAccount }: CommandsCellProps) => {
  const setDialogInfo = useSetAtom(dialogInfoAtom)
  const handleEditButtonClick = React.useCallback<
    EH<TooltipButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'update', brandAccount })
  }, [brandAccount, setDialogInfo])

  const handleDeleteButtonClick = React.useCallback<
    EH<TooltipButtonProps, 'onClick'>
  >(() => {
    setDialogInfo({ dialogType: 'delete', brandAccount })
  }, [brandAccount, setDialogInfo])

  return (
    <td>
      <HStack backgroundColor="transparent" justify="center" spacing={0}>
        <TooltipButton
          fillMode="flat"
          icon="edit"
          title="Edit"
          onClick={handleEditButtonClick}
        />

        <TooltipButton
          fillMode="flat"
          icon="delete"
          title="Delete"
          onClick={handleDeleteButtonClick}
        />
      </HStack>
    </td>
  )
}
